import { useRouteError, isRouteErrorResponse, useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { styled, useTheme } from '@mui/material/styles'
import Stack from '@mui/material/Stack'
import Button from '@mui/material/Button'
import useMediaQuery from '@mui/material/useMediaQuery'

import Header from './components/Header'
import { useAppSelector } from '../../store'
import { getCurrentUserToken } from '../../store.slice'

function ErrorMessage() {
  const error = useRouteError()
  const { t } = useTranslation()

  if (isRouteErrorResponse(error)) {
    switch (error.status) {
      case 404:
        return <h1>{t("Cette page n'existe pas!")}</h1>
      case 401:
        return <h1>{t("Vous n'êtes pas autorisé à voir cette page!")}</h1>
      case 502:
      case 503:
        return <h1>{t('Il semble que notre API est en panne')}</h1>
      case 418:
        return <h1>🫖</h1>
      default:
        break
    }
  }

  return <h1>{t("Quelque chose s'est mal passé")}</h1>
}

const Body = styled('main')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  backgroundColor: theme.palette.background.default,
  color: theme.palette.text.primary,
  height: '100vh',
  width: '100vw',
  overflow: 'hidden',

  '@supports (height: 100dvh)': {
    height: '100dvh',
  },
}))

export default function RootBoundary() {
  const { t } = useTranslation()
  const theme = useTheme()
  const mobileView = useMediaQuery(theme.breakpoints.down('md'))
  const navigate = useNavigate()

  const token = useAppSelector(getCurrentUserToken)

  return (
    <Body>
      {!mobileView && token && <Header />}
      <Stack alignItems="center" justifyContent="center" flex="1 0 fit-content" gap="1rem">
        <ErrorMessage />
        <Stack alignItems="center" justifyContent="center" gap="1rem" direction="row">
          <Button onClick={() => navigate('/')} variant="outlined">
            {t('Retour à la page d’accueil')}
          </Button>
          <Button onClick={() => navigate(0)} variant="contained">
            {t('Recharger la page')}
          </Button>
        </Stack>
      </Stack>
      {mobileView && token && <Header />}
    </Body>
  )
}
